import moment from "moment/moment";
import isEmpty from "is-empty";

export default {

    now: () => {
        return moment.now();
    },

    formatDateMoment: (date, format) => {
        return date.format(format);
    },

    formatDateString: (dateStr, format) => {
        if (isEmpty(dateStr)) {
            return "-";
        }
        return moment(dateStr).format(format);
    },

    formatDateTimestamp: (timestamp, format) => {
        return moment.unix(timestamp).format(format);
    },
}